export const generateThumbnailAsFile = async (file, maxWidth = 100, maxHeight = 100) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (event) => {
            const img = new Image()

            img.onload = () => {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')

                // Calcula as dimensões da miniatura
                let width = img.width
                let height = img.height

                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width
                        width = maxWidth
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height
                        height = maxHeight
                    }
                }

                canvas.width = width
                canvas.height = height

                // Redimensiona a imagem no canvas
                ctx.drawImage(img, 0, 0, width, height)

                // Converte o canvas para Blob
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            // Cria um novo arquivo a partir do Blob
                            const thumbnailFile = new File([blob], `thumbnail-${file.name}`, {
                                type: blob.type,
                                lastModified: Date.now(),
                            })
                            resolve(thumbnailFile) // Retorna o arquivo gerado
                        } else {
                            reject(new Error('Erro ao gerar thumbnail'))
                        }
                    },
                    'image/jpeg', // Tipo de imagem (você pode ajustar para PNG, se necessário)
                    0.8 // Qualidade da imagem (0.8 = 80%)
                )
            }

            img.onerror = () => reject(new Error('Erro ao carregar imagem'))
            img.src = event.target.result // Define o src da imagem
        }

        reader.onerror = () => reject(new Error('Erro ao ler o arquivo'))
        reader.readAsDataURL(file) // Lê o arquivo original como Data URL
    })
}

/**
 * Gera uma miniatura de um arquivo de imagem.
 * Gera o format webp por ser o mais moderno e menor ainda que jpeg com qualidade igual ou maior.
 * Safari no iOS parece que não suporta gerar webp apenas de exibir!
 */
export const generateThumbnailBlob = (originalFile, width = 96, height = 96, stretched = false, quality = 1.0, thumnType = 'image/webp') => {

    return new Promise((resolve, reject) => {

        const imageUrl = URL.createObjectURL(originalFile)
        thumnType = thumnType || originalFile.type

        if (thumnType.includes('webp') && !supportsWebP()) {
            thumnType = 'image/jpeg'
        }

        const img = new Image()
        img.crossOrigin = 'anonymous' // importante se a imagem for externa

        img.onerror = () => reject(new Error('Erro ao carregar imagem'))
        img.src = imageUrl

        img.onload = () => {

            const canvas = document.createElement('canvas')

            if (stretched) {
                canvas.width = width
                canvas.height = height
            } else {
                if (img.width > img.height) {
                    canvas.width = width
                    canvas.height = (img.height * width) / img.width
                } else {
                    canvas.width = (img.width * height) / img.height
                    canvas.height = height
                }
            }

            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

            canvas.toBlob((blob) => {
                if (blob) {

                    const ext = thumnType.split('/')[1] || 'webp'
                    const baseName = originalFile.name.replace(/\.[^/.]+$/, '') // Remove extensão original
                    const thumbName = `${baseName}.${ext}`

                    // Cria o file a partir do Blob apenas para ter o 'name'.
                    const thumbFile = new File([blob], thumbName, {
                        type: blob.type,
                        lastModified: Date.now(),
                    })
                    resolve(thumbFile)
                } else {
                    reject(new Error('Erro ao gerar thumbnail'))
                }
            }, thumnType, quality)
        }

    })

}

/**
 * Converte uma imagem para o formato WebP.
 */
export const convertImageToWebP = (originalFile, quality = 1.0) => {
    return new Promise((resolve, reject) => {

        const imageUrl = URL.createObjectURL(originalFile)
        const mimeType = supportsWebP() ? 'image/webp' : 'image/jpeg'
        const img = new Image()

        img.crossOrigin = 'anonymous'
        img.onerror = () => reject(new Error('Erro ao carregar imagem'))
        img.src = imageUrl

        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height

            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

            canvas.toBlob((blob) => {
                if (blob) {
                    const baseName = originalFile.name.replace(/\.[^/.]+$/, '')
                    const newName = `${baseName}.webp`

                    const newFile = new File([blob], newName, {
                        type: blob.type,
                        lastModified: Date.now()
                    })

                    resolve(newFile)
                } else {
                    reject(new Error('Erro ao converter imagem para WebP'))
                }
            }, mimeType, quality)
        }
    })
}

export const getImageInfo = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (e) => {
            const img = new Image()
            img.onload = () => resolve(img)
            img.onerror = () => reject(new Error('Erro ao carregar imagem'))
            img.src = e.target.result
        }

        reader.onerror = () => reject(new Error('Erro ao ler arquivo'))
        reader.readAsDataURL(file)
    })
}


export function supportsWebP() {
    const canvas = document.createElement('canvas')
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0
}
